import React from 'react'

import { Hero } from './Hero'
import { Stats } from './Stats'
import { Products } from './Products'
import { Sponsors } from './Sponsors'
import { Mailchimp } from './Mailchimp'

export default () => (
  <>
    <Hero />
    <Stats />
    <Products />
    <Sponsors />
    <Mailchimp />
  </>
)
